import React from "react";
import { useTable, useRowSelect, useFilters } from "react-table";
import "./ReactTable.css";

const RowSelectTable = ({ id, columns, data, onRowSelect }) => {
  const modifiedColumns = React.useMemo(
    () => [
      {
        id: "selection",
        Header: ({ getToggleAllRowsSelectedProps }) => (
          <input type="checkbox" {...getToggleAllRowsSelectedProps()} />
        ),
        Cell: ({ row }) => (
          <input type="checkbox" {...row.getToggleRowSelectedProps()} />
        ),
      },
      ...columns,
    ],
    [columns]
  );

  // 🛠️ Setup table with row selection
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    selectedFlatRows, // 🚀 Get selected rows
  } = useTable(
    {
      columns: modifiedColumns,
      data,
    },
    useFilters, 
    useRowSelect, // Enable row selection
  );

  // 🛠️ Use effect to capture selected rows
  React.useEffect(() => {
    if (onRowSelect) {
      onRowSelect(selectedFlatRows.map((row) => row.original));
    }
  }, [selectedFlatRows, onRowSelect]);

  return (
    <div className="table-responsive">
      <table id={id} {...getTableProps()} className="table display">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>
                  <span className="ml-1">{column.render("Header")}</span>
                  {column.canFilter && column.render("Filter")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td
                      style={{ textAlign: cell?.column?.justify || "left" }}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={modifiedColumns.length} className="norecordfound">
                <span>No Records Found</span>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RowSelectTable;
